module.exports = __webpack_public_path__ + "img/178.e7964635.jpg";